import {useState} from 'react'
import StationDetailsForm from './StationDetailsForm';
import StationDetailsList from './StationDetailsList';

const StationDetails = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <StationDetailsForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <StationDetailsList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default StationDetails